import { COLORS } from "constants/chartCommons";
import { LD12Chart } from "store/slice/charts/chartsSlice.types";
import { hubAverageColor } from "./BehaviouralBreakdown.functions";
import { isEmpty } from "lodash";

export const getOptions = ({
    chartData,
    chartRef,
    handleDrawChart,
    handleLegendItemClick,
}: {
    chartData: LD12Chart;
    chartRef?: Highcharts.Chart;
    handleDrawChart: (chart: Highcharts.Chart, isExporting: boolean, isRedrawing: boolean) => void;
    handleLegendItemClick: (serie: Highcharts.Series) => void;
}): Highcharts.Options => {
    return {
        chart: {
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            animation: false,
            className: "BehaviouralBreakdownChart",
            events: {
                load: function () {
                    handleDrawChart(this, false, false);
                },
                redraw: function () {
                    handleDrawChart(this, false, true);
                },
            },
            style: {
                fontFamily: "Lato, sans-serif",
            },
        },
        credits: {
            text: "",
        },
        title: {
            text: undefined,
        },
        exporting: {
            menuItemDefinitions: {
                downloadPNG: { text: "Download PNG Image" },
                downloadSVG: { text: "Download SVG Image" },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadSVG"],
                },
            },
            chartOptions: {
                chart: {
                    events: {
                        load: function () {
                            if (this.plotHeight < 460) {
                                this.setSize(null, 460, false);
                            }
                            this.setSize(null, null, false);
                            handleDrawChart(this, true, false);
                        },
                    },
                },
                series: chartData?.series_labels.map((serie, i) => {
                    const isHubAverage = serie.entity_name === "Hub Average";

                    return {
                        type: "scatter",
                        name: serie.entity_name ?? "",
                        color: isHubAverage ? hubAverageColor : COLORS[i],
                        showInLegend: serie.enabled,
                    };
                }),
            },
        },
        yAxis: {
            lineWidth: 0,
            tickInterval: 10,
            gridLineWidth: 0,
            gridLineColor: "transparent",
        },
        xAxis: {
            lineWidth: 0,
            gridLineWidth: 0,
            gridLineColor: "transparent",
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            series: {
                lineWidth: 0,
                color: "transparent",
                marker: {
                    lineColor: "transparent",
                    radius: 0,
                    states: {
                        hover: {
                            enabled: false,
                        },
                    },
                },
                states: {
                    hover: {
                        halo: null,
                    },
                },
                events: {
                    legendItemClick: function () {
                        handleLegendItemClick(this);
                    },
                },
            },
        },
        legend: {
            align: "center", // Center the legend horizontally
            verticalAlign: "bottom", // Position it at the bottom
            itemStyle: {
                fontWeight: "600",
            },
        },
        series: chartData?.series_labels.map((serie, i) => {
            const isHubAverage = serie.entity_name === "Hub Average";
            const isSerieVisible = chartRef?.series[i]?.visible;

            return {
                type: "scatter",
                name: serie.entity_name ?? "",
                color: isHubAverage ? hubAverageColor : COLORS[i],
                showInLegend: serie.enabled,
                className: !serie.enabled ? "disabled-element" : "",
                ...(!isEmpty(chartRef) ? { visible: isSerieVisible } : {}),
                marker: {
                    symbol: "circle",
                    radius: 8,
                },
            };
        }),
    };
};
